import { render } from "./PortfolioPopout.vue?vue&type=template&id=a4db18f6&scoped=true"
import script from "./PortfolioPopout.vue?vue&type=script&lang=js"
export * from "./PortfolioPopout.vue?vue&type=script&lang=js"

import "./PortfolioPopout.vue?vue&type=style&index=0&id=a4db18f6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4db18f6"]])

export default __exports__